import { Component, input } from '@angular/core';
import { SynergyFormsModule, SynIconComponent, SynTooltipComponent } from '@synergy-design-system/angular';

@Component({
  selector: 'app-help-text',
  template: `
    <div class="flex-row gap-1" style="align-items: flex-start">
      <div style="flex-grow: 1">
        <ng-content />
      </div>

      @if (enabled()) {
        <syn-tooltip>
          <syn-icon
            style="font-size: var(--syn-font-size-x-large); color: var(--syn-color-primary-600)"
            name="help_fill" />
          <span slot="content">
            <ng-content select="[helpText]" />
          </span>
        </syn-tooltip>
      }
    </div>
  `,
  styles: [
    `

    `,
  ],
  imports: [
    SynIconComponent,
    SynTooltipComponent,
    SynergyFormsModule,
  ],
})
export class HelpTextComponent {
  enabled = input(true);
}
